module.exports = __webpack_public_path__ + "img/svg/result-loser-trophy.284000f524cfe4e64896506278e9f478.svg";